import { cn } from '@/shared/lib/utils'

export interface PageTitleProps {
  /**
   * Заголовок страницы
   */
  title: string
  /**
   * Подзаголовок / описание (опционально)
   */
  subtitle?: string
  /**
   * Дополнительные классы
   */
  className?: string
}

/**
 * UI компонент: Заголовок страницы
 * 
 * Премиальная типографика для заголовков основных страниц.
 * Используется после MainHeader.
 * 
 * @example
 * ```tsx
 * <PageTitle 
 *   title="Дневник" 
 *   subtitle="Ваши чайные впечатления"
 * />
 * ```
 */
export function PageTitle({ title, subtitle, className }: PageTitleProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <h1 className="text-2xl sm:text-3xl font-bold text-ink dark:text-white">
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400">
          {subtitle}
        </p>
      )}
    </div>
  )
}

